import React, { useState } from 'react';
import ChatExample, { ClientId } from './ChatExample';
import { useNavigation } from '../context/NavigationContext';

// Mirror of the extension's Overview section: shows what the AI connector looks like in use,
// so the landing page demos both install paths instead of just the extension.
const AIChatOverview: React.FC = () => {
  const { navigate } = useNavigation();
  const [client, setClient] = useState<ClientId>('claude');

  return (
    <div className="overview ai-overview">
      <div className="overview-text ai-overview-text">
        <h1>Or just ask your AI</h1>
        <h2>
          Connect Stashr to Claude, ChatGPT, or Gemini and ask which card to use. It knows your
          wallet and this quarter's bonus categories.
        </h2>
        <button
          onClick={() => navigate('/mcp')}
          className="primary-button mcp-button white-color ai-overview-button"
        >
          Connect in seconds →
        </button>
      </div>

      <div className="ai-overview-chat">
        <ChatExample client={client} onClientChange={setClient} />
      </div>
    </div>
  );
};

export default AIChatOverview;
